const getFaqCategoryApi = async (options?: ApiRestOptions) => {
  return apiFetchRequest<ApiRestResult<FaqCategory>>("/data/faq/category", options);
};

export { getFaqCategoryApi };
